import { useSetAtom } from "jotai";
import { useEffect } from "react";

import {
  SessionClub,
  sessionCurrentClubAtom,
  sessionCurrentClubSlugAtom,
} from "../../../../../Session";

export const VerifiedAuthenticationModalAtomHydrator = ({
  sessionClub,
}: {
  sessionClub: SessionClub;
}) => {
  const setSessionCurrentClub = useSetAtom(sessionCurrentClubAtom);
  const setSessionClubSlug = useSetAtom(sessionCurrentClubSlugAtom);

  useEffect(() => {
    setSessionCurrentClub({
      ...sessionClub,
      logoImage: sessionClub.logoImage ?? "",
      id: "",
    });
    setSessionClubSlug(sessionClub.slug);
  }, [sessionClub, setSessionCurrentClub, setSessionClubSlug]);

  return <></>;
};
